import Flickity from 'flickity'
import 'flickity-as-nav-for'
import 'flickity-imagesloaded'
import { getElement, getElements } from '../utils/functional'

/* eslint-disable */
export default class ReviewsCarouselMain {
  constructor(el) {
    this.els = {
      el,
      carRev: getElement('.car-Rev'),
      carRevNav: getElement('.car-RevNav'),
      revNavs: getElements('.rev-Nav')
    }

    if (el) {
      const flkty = new Flickity(el, {
        // options
        cellAlign: 'center',
        contain: true,
        cellSelector: '.rev-Main',
        imagesLoaded: true,
        wrapAround: true,
        selectedAttraction: 0.015
      })
    }

    const carMain = document.querySelector('.car-Rev')

    if (this.els.carRevNav) {
      const flkty2 = new Flickity(this.els.carRevNav, {
        // options
        cellAlign: 'center',
        contain: true,
        imagesLoaded: true,
        wrapAround: true,
        asNavFor: carMain,
        prevNextButtons: false,
        selectedAttraction: 0.01
      })
    }

    // this.els.revNavs.forEach(nav => {
    //   nav.addEventListener('click', e => {
    //     const index = nav.getAttribute('data-index')
    //     this.els.revNavs.forEach(nav => {
    //       nav.classList.remove('rev-Nav-active')
    //     })
    //
    //     nav.classList.add('rev-Nav-active')
    //     flkty.select(index, true, false)
    //   })
    // })
    //
    // flkty.on('change', function (index) {
    //   getElements('.rev-Nav').forEach(nav => {
    //     if (parseInt(nav.getAttribute('data-index')) === index) {
    //       nav.classList.add('rev-Nav-active')
    //     } else {
    //       nav.classList.remove('rev-Nav-active')
    //     }
    //   })
    // })
  }
}
/* eslint-enable */
